import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    {...props}
  >
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
    <path d="M3.5 13H6c2 0 4 .7337 4 3v5M4 9h16m.5 4H18c-2 0-4 .7162-4 3v5" stroke={color} strokeWidth="2" />
  </svg>
);
